import InputAmount from '../../../components/Atoms/Inputs/InputAmount/InputAmount';

const CardTotalUnits = ({ totalUnits }: any) => {
  return (
    <blockquote className="CardTotalUnits InputAmount-edit">
      <InputAmount
          title="How many units are in the property?"
          type="edit"
          text={null}
          value={totalUnits}
          disabled={true}
        />
    </blockquote>
  );
};

export default CardTotalUnits;
